module.exports = __webpack_public_path__ + "static/img/banner.e6946c6e.jpg";